<template>
  <div name="detail-template">
    <slot name="head">HEAD</slot>
    <slot name="body">BODY</slot>
  </div>
</template>

<script>
import tab13Popup from 'components/hres31x/tab13Popup'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'detail-template',
  data () {
    return {
      topicDisp: true
    }
  },
  methods: {
    toggleDisp () {
      this.topicDisp = !this.topicDisp
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setYearRangeOutput (year) {
      return assetsUtils.getYearRangeOutput(year)
    }
  },
  props: [ 'index', 'labels', 'detail', 'pcDisp', 'mapTyptency', 'getDetailTab13Popup', 'detailTab13Popup', 'tab13PopupColumn', 'receivedHres31xdataDetailTab13Popup' ],
  components: {
    tab13Popup
  }
}
</script>


// WEBPACK FOOTER //
// detailTemplate.vue?6137ed50